import React, {useEffect, useState} from "react";
import ReactPlayer from "react-player/lazy";
import {Box, Container, Grid, makeStyles} from "@material-ui/core";
import useWindowDimensions from "../hooks/useWindowDimensions";
import PlayIcon from '@material-ui/icons/PlayCircleFilledWhite';

const esVideos = [
    {
        title: "",
        source: "https://vimeo.com/556905628/37b887a6f4",
        // source: 'https://luxboreal.skene.tv/v/_inicio.mp4',
        id: '554169867',
        image: "/assets/img/FONDO_CLEAN.png"
    },
    {
        title: "",
        source: "https://vimeo.com/556786134/edf32b3e6a",
        // source: 'https://luxboreal.skene.tv/v/_ruta_negro.mp4',
        id: '554169867',
        image: "/assets/img/L0.gif"
    },
    {
        title: "",
        source: "https://vimeo.com/556771423/cc939785b1",
        // source: 'https://luxboreal.skene.tv/v/_ruta_azul.mp4',
        id: '554169867',
        image: "/assets/img/C0.gif"
    },
    {
        title: "",
        source: "https://vimeo.com/556880684/7bb7498cb5",
        // source: 'https://luxboreal.skene.tv/v/_ruta_rojo.mp4',
        id: '554169867',
        image: "/assets/img/R0.gif"
    },
];

const enVideos = [
    {
        title: "",
        source: "https://vimeo.com/573805236/0ce5c921b1",
        // source: 'https://luxboreal.skene.tv/v/_inicio.mp4',
        id: '554169867',
        image: "/assets/img/FONDO_CLEAN.png"
    },
    {
        title: "",
        source: "https://vimeo.com/573821179/5527b2a23b",
        // source: 'https://luxboreal.skene.tv/v/_ruta_negro.mp4',
        id: '554169867',
        image: "/assets/img/R0.gif"
    },
    {
        title: "",
        source: "https://vimeo.com/573823876/8b9ff06c68",
        // source: 'https://luxboreal.skene.tv/v/_ruta_azul.mp4',
        id: '554169867',
        image: "/assets/img/C0.gif"
    },
    {
        title: "",
        source: "https://vimeo.com/573825816/cfccbd1198",
        // source: 'https://luxboreal.skene.tv/v/_ruta_rojo.mp4',
        id: '554169867',
        image: "/assets/img/L0.gif"
    },
];

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: '#000',
        minHeight: '100vh',
        width: '100%',
        padding: 0,
        margin: 0,
        paddingLeft: '15px',
        paddingRight: '15px',
        '&.MuiContainer-maxWidthLg': {
            maxWidth: '100%',
        }
    },
    grid: {
        minHeight: '100vh',
    },
    startContainer: {
        padding: 0,
        backgroundSize: "contain",
        marginLeft: "auto",
        marginRight: "auto",
        overflow: "hidden",
        backgroundImage: `url('/assets/img/FONDO_CLEAN.png')`,
    },
    selectionContainer: {
        padding: 0,
        backgroundSize: "contain",
        marginLeft: "auto",
        marginRight: "auto",
        overflow: "hidden",
    },
    start: {
        backgroundColor: 'transparent',
        overflow: "hidden",
        cursor: "pointer",
        '& svg': {
            fontSize: "calc(20vw)",
            fill: "#fff",
            opacity: "0.5",
        },
        '& svg:hover': {
            opacity: "0.6",
        }
    },
    item: {
        backgroundColor: 'transparent',
        overflow: "hidden",
        cursor: "pointer",
        '& img': {
            width: "100%",
        },

    }
}));

const getInitialState = () => {
    const locationParts = window.location.href.split('#');
    if (locationParts[1] && locationParts[1] === 'selecciona' || locationParts[1] === 'select') {
        return {isStart: false, isEnded: true};
    } else {
        return {isStart: true, isEnded: false};
    }
}

const getLanguage = () => {
    return window.location.pathname.includes("/en") ? "en" : "es";
}

const getTree = () => {
    return getLanguage() === "es" ? [[2, 3, 4]] : [[2, 3, 4]];
}

const getVideos = () => {
    return getLanguage() === "es" ? esVideos : enVideos;
}

const InteractiveVideo = () => {
    const classes = useStyles();
    const [current, setCurrent] = useState(1);
    const [isStart, setIsStart] = useState(getInitialState().isStart);
    const [isEnded, setIsEnded] = useState(getInitialState().isEnded);
    const {height, width} = useWindowDimensions();
    const tree = getTree();
    const videos = getVideos();

    const currentVideoUrl = videos[current - 1].source;

    const clickNext = (index) => {
        setCurrent(index);
        setIsEnded(false);
    };

    const getPlayerSize = () => {
        if (width/1.77 > height ) {
            return {width: (height - 30) * 16/9, height: (height - 30), marginTop: 15};
        } else {
            return {width: (width - 30), height: (width - 30) * 9/16, marginTop: 0};
        }
    }

    const onEnded = () => {
        if (!tree[current-1] && getLanguage() === "es") {
            window.location.href = "https://www.luxboreal.org/postshow";
        } else if (!tree[current-1] && getLanguage() === "en") {
            window.location.href = "https://www.luxboreal.org/1977-postshow";
        } else {
            setIsEnded(true)
        }
    }

    return (
        <Container className={classes.root}>
            <Grid container alignItems='center' justify='center' className={classes.grid}>
                {
                    isStart &&
                    <Grid item xs={12}>
                        <Grid container justify="center" spacing={0} className={classes.startContainer}
                              onClick={() => setIsStart(false)}
                              style={{
                                  width: `${getPlayerSize().width}px`,
                                  height: `${getPlayerSize().height}px`,
                              }}
                        >
                            <Grid item xs={12} className={classes.start}>
                                <Box display={"flex"} justifyContent={"center"} height={"100%"} flexDirection={"column"}>
                                    <Box display={"flex"} justifyContent={"center"} flexDirection={"row"}>
                                        <PlayIcon/>
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>
                    </Grid>
                }
                {
                    isStart === false && isEnded === false &&
                    <Grid item xs={12} className={classes.playerSized}>
                        <ReactPlayer
                            url={currentVideoUrl}
                            playing={true}
                            width={getPlayerSize().width}
                            height={getPlayerSize().height}
                            style={{marginLeft: "auto", marginRight: "auto"}}
                            controls={true}
                            config={{
                                file: {
                                    forceVideo: true
                                }
                            }}
                            onEnded={onEnded}
                        />
                    </Grid>
                }

                {
                    isStart === false && isEnded &&
                    <Grid item xs={12}>
                        <Grid container justify="center" spacing={0} className={classes.selectionContainer}
                              style={{
                                  width: `${getPlayerSize().width}px`,
                                  height: `${getPlayerSize().height}px`,
                                  backgroundImage: getLanguage() === "es" ? `url('/assets/img/FONDO.png')` : `url('/assets/img/FONDO_EN.jpg')`,
                              }}
                        >
                            {
                                tree[current - 1] &&
                                tree[current - 1].map(i => {
                                    return (
                                        <Grid item key={i} xs={4} className={classes.item}>
                                            <img src={videos[i - 1].image} onClick={() => clickNext(i)}/>
                                        </Grid>
                                    );
                                })
                            }
                        </Grid>
                    </Grid>
                }

            </Grid>
        </Container>
    );
}

export default InteractiveVideo;
